import { get } from 'utils';

export default function getFacets({ facetsEndpoint, params }, callback) {
  const controller = new AbortController();

  get(
    { apiKey: facetsEndpoint },
    { params, config: { signal: controller.signal } }
  )
    .then(res => callback(null, res))
    .catch(err => callback(err, {}));

  return controller;
}
